import { useState } from "react";
import styles from "./../styles.module.css";
import Table from "../../../TableConstructor";
import RowEquipamento from "../../../TableConstructor/Row/RowEquipamento";
import { Equipamento } from "../../../../model/PlanoDeTrabalho/AquisicaoDeEquipamentos";
import CampoTextoLongo from "../../../Campo/CampoTextoLongo";

type Props = {
  voltarPagina: Function;
  itens: Equipamento[];
  manutencao: string;
};

function Equipamentos({ voltarPagina, itens, manutencao }: Props) {
  const [showAddEquipamento, setAddEquipamento] = useState(false);
  const [showEditEquipamento, setEditEquipamento] = useState(-1);

  return (
    <div>
      <h2 className={styles.titulo}>
        6. Relação dos Equipamentos e Materiais Permanentes:
      </h2>
      <div>
        <Table
          listTitle={[
            "Item",
            "Nome e Especificação do Equipamento",
            "Quantidade",
            "Valor Unitário",
            "Valor Total",
            "",
          ]}
          styleList={[1, 0, 1, 1, 1, 0]}
        >
          {itens.map((itemObj, index) => (
            <RowEquipamento itemObj={itemObj} metaIndex={index} key={index} />
          ))}
        </Table>
        <hr className={styles.separador} />
        <CampoTextoLongo
          title="Manutenção Preventiva e Corretiva dos Equipamentos a Serem Adquiridos"
          value={manutencao}
          hideAsterisk
        />
      </div>
      <hr className={styles.separador} />
      <div className="flex justify-start">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
      </div>
    </div>
  );
}

export default Equipamentos;
